import { Building2, Users, Activity, TrendingDown } from "lucide-react";

const steps = [
  {
    icon: Building2,
    title: "Partner Setup",
    description: "Schedule a demo, customize your plan, and onboard your team in under 2 weeks",
  },
  {
    icon: Users,
    title: "Employee Enrollment",
    description: "Employees complete 2-minute health assessment and physician approval (usually same day)",
  },
  {
    icon: Activity,
    title: "Begin Treatment",
    description: "Medication ships within 48 hours. Monthly telehealth check-ins and community events begin",
  },
  {
    icon: TrendingDown,
    title: "Track & Optimize",
    description: "Real-time dashboard shows participation, outcomes, and ROI. Quarterly business reviews included",
  },
];

const HowItWorks = () => {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Simple Implementation, Powerful Results
          </h2>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="relative">
            {/* Connecting line - hidden on mobile */}
            <div className="hidden md:block absolute top-16 left-0 right-0 h-0.5 bg-gradient-to-r from-[#0D1B2A] to-[#1B3A4B]" />
            
            <div className="grid md:grid-cols-4 gap-8">
              {steps.map((step, index) => (
                <div key={index} className="relative text-center">
                  {/* Step number and icon */}
                  <div className="relative z-10 mx-auto mb-4">
                    <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#0D1B2A] to-[#1B3A4B] flex items-center justify-center mx-auto shadow-lg">
                      <step.icon className="w-8 h-8 text-white" />
                    </div>
                    <div className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-white border-2 border-[#0D1B2A] flex items-center justify-center text-sm font-bold text-[#0D1B2A]">
                      {index + 1}
                    </div>
                  </div>
                  
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{step.title}</h3>
                  <p className="text-sm text-gray-600">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
